import { FieldValues, Path } from "react-hook-form";

import { Input } from "@/components/Form/Base/input.component";

import { BaseField } from "../BaseField/BaseField.component";
import { FormValuesExploded } from "../formField.types";

type FixedFieldProps<T extends FieldValues> = FormValuesExploded<T> & {
    displayedValue: string;
};

const FixedField = <T extends FieldValues>({
    name,
    label,
    microCopy,
    required,
    hideLabel,
    hideMicroCopy,
    optionalIndication,
    requiredIndication,
    test,
    tooltip,
    displayedValue
}: FixedFieldProps<T>) => {
    return (
        <BaseField<T, Path<T>>
            name={name}
            label={label}
            microCopy={microCopy}
            required={required}
            hideLabel={hideLabel}
            hideMicroCopy={hideMicroCopy}
            optionalIndication={optionalIndication}
            requiredIndication={requiredIndication}
            tooltip={tooltip}
        >
            {({ field }) => {
                return (
                    <>
                        <Input
                            {...field}
                            type="hidden"
                            id={name}
                            data-test={test}
                        />
                        <div>{displayedValue}</div>
                    </>
                );
            }}
        </BaseField>
    );
};

export { FixedField };
